import React from 'react';
import { StarIcon } from 'lucide-react';
const metrics = [{
  value: '+500',
  label: 'Clientes'
}, {
  value: '4.9',
  label: 'Calificación'
}, {
  value: '100%',
  label: 'Satisfacción'
}];
export function TestimonialSection() {
  return <section aria-labelledby="testimonios-titulo" className="w-full bg-cream-50" data-id="element-297" data-mp="1r5g35wwrv1j8">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-20 lg:py-24" data-id="element-298" data-mp="1mcd4jad511w6">
        <div className="grid gap-8 lg:grid-cols-[1.4fr_0.6fr] lg:items-center lg:gap-20" data-id="element-299" data-mp="2119itp5sfb58">
          <div data-id="element-300" data-mp="1w3ra9zvomxxr">
            <h2 id="testimonios-titulo" className="font-display text-[11px] font-bold uppercase tracking-[0.2em] text-moss-600 sm:text-xs sm:tracking-[0.22em]" data-id="element-301" data-mp="1w1wqwq027dvs">
              Lo que dicen quienes ya lo hicieron
            </h2>
            <blockquote className="mt-4 sm:mt-6" data-id="element-302" data-mp="fogct6tziwru">
              <p className="font-display text-lg font-semibold leading-snug tracking-tight text-forest-900 sm:text-[2rem]" data-id="element-303" data-mp="foyewk3bw57o">
                “Me pasó eso de empezar con todo y después aflojar. Con el desafío de 21 días
                encontré una forma más amable de cambiar. En la semana 2 ya notaba orden en mi rutina
                y, lo mejor, no me sentía agotada.”
              </p>
              <footer className="mt-4 flex items-center gap-3 sm:mt-6" data-id="element-304" data-mp="29vjm9vujnvaz">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-forest-800 font-display text-xs font-bold text-cream-50 sm:h-11 sm:w-11 sm:text-sm" data-id="element-305" data-mp="2eo2xwn9o8gd5">
                  CS
                </span>
                <div data-id="element-306" data-mp="2nn7vnrdes5o9">
                  <cite className="not-italic font-display text-sm font-bold text-forest-900 sm:text-base" data-id="element-307" data-mp="2nmoh8kmyvzez">
                    Camila Sosa
                  </cite>
                  <p className="flex items-center gap-1 text-xs text-forest-800/70 sm:text-sm" data-id="element-308" data-mp="2xlnqa4bn9x2i">
                    <StarIcon className="h-3.5 w-3.5 fill-moss-600 text-moss-600" aria-hidden="true" data-id="element-309" data-mp="yamm5ar2kbcd" />
                    4.9/5 · +500 personas ya empezaron
                  </p>
                </div>
              </footer>
            </blockquote>
          </div>

          <dl className="grid grid-cols-3 gap-3 border-t border-cream-300 pt-5 sm:gap-4 sm:pt-8 lg:grid-cols-1 lg:border-l lg:border-t-0 lg:pl-10 lg:pt-0" data-id="element-310" data-mp="qaq0jevk32nj">
            {metrics.map(metric => <div key={metric.label} data-id="element-311" data-mp="105i18rkfq5mj">
                <dt className="sr-only" data-id="element-312" data-mp="1e6kmj23lvbwe">{metric.label}</dt>
                <dd data-id="element-313" data-mp="1e515h9a4kwtk">
                  <span className="block font-display text-2xl font-extrabold tracking-tight text-forest-900 sm:text-3xl lg:text-4xl" data-id="element-314" data-mp="1e4hlzo4tu0df">
                    {metric.value}
                  </span>
                  <span className="mt-0.5 block text-xs text-forest-800/70 sm:mt-1 sm:text-sm" data-id="element-315" data-mp="1nyqfof5lfzd6">
                    {metric.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}